import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { GlassCard } from "@/components/GlassCard";
import SEO from "@/components/SEO";
import api from "@/lib/api";
import { container, goldBtn } from "@/lib/constants";

export default function ConfirmEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("working");
  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.get(`/auth/confirm-email?token=${token}`).then(() => setState("done")).catch(() => setState("error"));
  }, [token]);
  return (
    <PublicLayout>
      <SEO title="Confirm email" noindex />
      <section className={`${container} py-28`}>
        <GlassCard className="max-w-lg mx-auto p-10 text-center">
          {state === "working" && <p className="text-sm text-muted-foreground">Confirming your email…</p>}
          {state === "done" && (
            <>
              <h1 className="pdg-serif text-3xl text-foreground">Email confirmed</h1>
              <p className="mt-3 text-sm text-muted-foreground">Thank you. Your application is now under review. We will be in touch within two business days.</p>
              <Link to="/auth" className={`${goldBtn} mt-8`}>Sign in</Link>
            </>
          )}
          {state === "error" && (
            <>
              <h1 className="pdg-serif text-3xl text-foreground">Link invalid</h1>
              <p className="mt-3 text-sm text-muted-foreground">This confirmation link is invalid or has already been used.</p>
              <Link to="/" className="mt-6 inline-block text-sm text-[hsl(var(--pdg-gold))]">Return home</Link>
            </>
          )}
        </GlassCard>
      </section>
    </PublicLayout>
  );
}
